import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Github, Twitter, MessageCircle, Send, ShieldCheck } from 'lucide-react';
import { EcosystemBridge } from './EcosystemBridge';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <>
      <EcosystemBridge />
    <footer className="border-t border-[#1a4138] py-12 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center">
                <span className="text-black font-extrabold text-base tracking-tight">WR</span>
              </div>
              <span className="text-white font-semibold text-lg">We·R2 Builders Portal</span>
            </div>
            <p className="text-slate-400 text-sm max-w-md leading-relaxed">
              {t('footer.tagline')}
            </p>

            {/* DMCC Badge */}
            <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#06120e] border border-[#1a4138]" data-testid="footer-dmcc-badge">
              <ShieldCheck className="w-4 h-4 text-primary" />
              <span className="text-xs text-slate-300 font-medium">DMCC Dubai Licensed</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-400 hover:text-white text-sm transition-colors">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <a href="#top10" className="text-slate-400 hover:text-white text-sm transition-colors">
                  {t('nav.top10')}
                </a>
              </li>
              <li>
                <a href="#sovereign-nodes" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-sovereign-nodes">
                  {t('nav.sovereignNodes')}
                </a>
              </li>
              <li>
                <Link to="/apply" className="text-slate-400 hover:text-white text-sm transition-colors">
                  {t('nav.apply')}
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-slate-400 hover:text-white text-sm transition-colors">
                  {t('nav.dashboard')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-white font-semibold mb-4">Connect</h4>
            <div className="flex flex-wrap gap-3">
              <a 
                href="https://github.com/wer2ecosystem" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-[#06120e] border border-[#1a4138] flex items-center justify-center text-slate-400 hover:text-primary hover:border-primary/40 transition-all"
                data-testid="footer-github"
              >
                <Github className="w-5 h-5" />
              </a>
              <a 
                href="https://twitter.com/wer2ecosystem" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-[#06120e] border border-[#1a4138] flex items-center justify-center text-slate-400 hover:text-primary hover:border-primary/40 transition-all"
                data-testid="footer-twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a 
                href="https://discord.gg/wer2ecosystem" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-[#06120e] border border-[#1a4138] flex items-center justify-center text-slate-400 hover:text-primary hover:border-primary/40 transition-all"
                data-testid="footer-discord"
              >
                <MessageCircle className="w-5 h-5" />
              </a>
              <a 
                href="https://t.me/wer2ecosystem" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-[#06120e] border border-[#1a4138] flex items-center justify-center text-slate-400 hover:text-primary hover:border-primary/40 transition-all"
                data-testid="footer-telegram"
              >
                <Send className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-[#1a4138] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} We·R2 Ecosystem. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-slate-500 hover:text-white text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-500 hover:text-white text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
};
